<template>
  <div>
    <div class="edit">
      <el-row>
        <el-col style="width: 85px; line-height: 38px;">星级规则：</el-col>
        <el-col :span="20">
          <el-form
            ref="editList"
            :model="formData"
            label-width="50px"
            class="demo-dynamic">
            <el-form-item
              v-for="(item, index) in formData.editList"
              :label="`${index + 1}星`"
              :key="index"
              :error="listErrors[index]"
            >
              获得<el-input v-model="item.num"/>小苹果，
              <el-input v-model="item.min"/>% &lt; 百分比 ≤
              <el-input v-model="item.max"/> %
              <el-button
                v-if="(index+1) === formData.editList.length"
                class="del"
                @click.prevent="removeDomain(item)">删除</el-button>
            </el-form-item>
            <el-form-item>
              <el-button
                type="primary"
                @click="submitForm()">提交</el-button>
              <el-button @click="addDomain">新增星级</el-button>
            </el-form-item>
          </el-form>
        </el-col>
      </el-row>
    </div>
    <el-table
      :data="tableData"
      border
      style="width: 100%">
      <el-table-column
        prop="operator"
        label="操作人"
        width="180"/>
      <el-table-column
        prop="date"
        label="操作时间"
        width="180"/>
      <el-table-column
        prop="content"
        label="操作内容"/>
    </el-table>
    <el-pagination
      :page-size="10"
      :total="100"
      class="page"
      background
      layout="total, prev, pager, next"
      @current-change="handleCurrentChange"/>
  </div>
</template>

<script>
export default {
  name: "ReviewConfig",
  data() {
    return {
      tableData: [{
        operator: "王小虎",
        date: "2016-05-02",
        content: "111",
      }, {
        operator: "王小虎",
        date: "2016-05-02",
        content: "111",
      }, {
        operator: "王小虎",
        date: "2016-05-02",
        content: "111",
      }, {
        operator: "王小虎",
        date: "2016-05-02",
        content: "111",
      }],
      formData: {
        editList: [
          { num: "", min: "", max: "" },
          { num: "", min: "", max: "" },
          { num: "", min: "", max: "" },
        ],
      },
      listErrors: [],
    };
  },
  methods: {
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
    },
    listValidate() {
      const errorMessage = "星级规则必须补充完整";
      const list = this.formData.editList;
      let result = true;
      this.listErrors = list.map(({
        num,
        min,
        max,
      }) => {
        const valid = !!(num && min && max);
        result = result && valid;
        return valid ? "" : errorMessage;
      });
      return result;
    },
    submitForm() {
      const valid = this.listValidate();
      if (valid) {
        console.log(this.formData.editList);
      }
    },
    removeDomain(item) {
      const index = this.formData.editList.indexOf(item);
      this.$confirm("是否删除规则？").then(() => {
        if (index !== -1) {
          this.formData.editList.splice(index, 1);
        }
      });
    },
    addDomain() {
      this.formData.editList.push({ num: "", min: "", max: "" });
    },
  },
};
</script>

<style scoped>
    .page{
        margin-top: 30px;
        text-align: center;
    }
    .edit .el-input{
        width: 100px;
        margin: 0 10px;
    }
    .edit .del{
        margin: 0 10px;
    }
</style>
<style>
    .edit .el-form-item .el-form-item__label{
        font-size: 16px;
        font-weight: bold;
    }
</style>
